import { formatNumber, truncateToDecimals } from "@/utils/numberFormat";
import { QUANTITY_DECIMALS } from "@/components/global.constants";
import { convertValue } from "@/utils/unitConverter";
import { getUnitLabel } from "@/utils/unitFormatter";

import FormSummary from "@/components/desktop/form/modal/FormSummary/FormSummary";

import useFilterStore from "@/stores/useFilterStore";

import styles from "./io-group-summary.module.scss";

const IOGroupSummary = ({ group }) => {
	const { filter } = useFilterStore();
	const unitMeasurement = filter?.unit_measurement || "kg_l";

	const headerItems = [
		{ label: "Código Salida", value: group.output_code },
		{ label: "Usuario", value: group.user_name },
	];

	return (
		<div className={styles.container}>
			<FormSummary items={headerItems} variant="default" />
			<div className={styles.tableWrapper}>
				<table className={styles.table}>
					<thead>
						<tr>
							<th>Producto</th>
							<th>Identificador</th>
							<th>Contenido Salida</th>
						</tr>
					</thead>
					<tbody>
						{group.details.map((detail) => {
							const convertedValue =
								detail.unit_measurement !== "u"
									? convertValue(detail.quantity_output, detail.unit_measurement, unitMeasurement)
									: detail.quantity_output;

							return (
								<tr key={detail.application_id}>
									<td>{detail.product_name}</td>
									<td>{detail.product_code}</td>
									<td>
										{formatNumber(truncateToDecimals(convertedValue, QUANTITY_DECIMALS), QUANTITY_DECIMALS)}
										{getUnitLabel(detail.unit_measurement, unitMeasurement)}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default IOGroupSummary;
